/**
 * A Javascript module to loadeding/refreshing options of a select2 list box using ajax based on selection of another select2 list box.
 * 
 * @url : https://gist.github.com/ajaxray/187e7c9a00666a7ffff52a8a69b8bf31
 * @auther : Anis Uddin Ahmad <anis.programmer@gmail.com>
 * 
 * Live demo - https://codepen.io/ajaxray/full/oBPbQe/
 * w: http://ajaxray.com | t: @ajaxray
 */
function Select2Cascade(parent, child, url, params) {
        var afterActions = [],
            options = params || {},
            parentOptions;

        // Register functions to be called after cascading data loading done
        this.then = function(callback) {
            afterActions.push(callback);
            return this;
        };

        if (parent && !params.isUpdating) {
            parentOptions = $.extend({}, options);

            parentOptions.placeholder = parentOptions.parentPlaceholder;

            parent.select2(parentOptions).on("change", function (e) {
                child.prop("disabled", true);
                var val = $(e.currentTarget).val(),
                    ids,
                    fallback_div,
                    fallback_url,
                    current_url = url;

                if (!val && options['fallbacks']) {
                    ids = Object.keys(options['fallbacks']);

                    for (var i = 0; i < ids.length; i++) {
                        fallback_div = $('#' + ids[i]);
                        fallback_url = options['fallbacks'][ids[i]];

                        if (fallback_div.val()) {
                            val = fallback_div.val();
                            current_url = fallback_url;
                            break;
                        }
                    }
                }
                if (params.value) {
                    child.data('original-value', params.value);
                }
                
                if (val) {
                    $.getJSON(current_url.replace(':parentId:', val), function(items) {
                        var newOptions = '<option value="">-- Select --</option>',
                            value = child.val() ? child.val() : child.data('original-value');
                        for(var id in items) {
                            newOptions += '<option data-text="' + items[id].text + '" value="'+ id +'"' + (value == id ? 'selected' : '') + '>' + items[id].label + '</option>';
                        }

                        child.select2('destroy').html(newOptions).prop("disabled", false)
                            .select2(options).trigger('change');
                        
                        afterActions.forEach(function (callback) {
                            callback(parent, child, items);
                        });
                    }.bind(this));
                } else if (!parent.val()) {
                    child.select2('destroy').html('').prop("disabled", false)
                        .select2(options).trigger('change');
                }
            }.bind(this));
        } else {
            child.prop("disabled", true);
            if (params.value) {
                child.data('original-value', params.value);
            }
            $.getJSON(url.replace(':parentId:', parent ? parent.val() : ''), function(items) {
                var newOptions = '<option value="">-- Select --</option>',
                    value = child.val() ? child.val() : child.data('original-value');
                for(var id in items) {
                    newOptions += '<option data-text="' + items[id].text + '" value="'+ id +'"' + (value == id ? 'selected' : '') + '>' + items[id].label + '</option>';
                }

                child.select2('destroy').html(newOptions).prop("disabled", false)
                    .select2(options).trigger('change');

                afterActions.forEach(function (callback) {
                    callback(parent, child, items);
                });
            }.bind(this));
        }
    }